<template>
  <el-container style="height: 100%;">
    <el-aside width="200px">
      <common-aside></common-aside>
    </el-aside>
    <el-container>
      <el-header>
        <common-header></common-header>
      </el-header>
      <common-tab></common-tab>
      <el-main>
        <router-view />
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import CommonAside from "../components/commonAside";
import CommonHeader from "../components/commonHeader";
import CommonTab from "../components/commonTab";
export default {
  components: {
    CommonAside,
    CommonHeader,
    CommonTab
  }
};
</script>

<style lang="stylus" scoped>
.el-header {
  background: #ffb100;
  border: none;
  height: 60px !important;
}

.el-aside {
  background: #fff;
}

.el-main {
  padding: 0px;
}
</style>
